
















import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';

@Component({
  name: 'DpAddToFavorite',
  components: {
    SvgIcon,
  },
})
export default class DpAddToFavorite extends Vue {
  @Prop() protected noLabel!: boolean;

  @Prop() protected isFavorite!: boolean;

  protected onClick() {
    this.$emit('change', !this.isFavorite);
  }
}
